import { authRoute } from 'helpers/routes'
import { injectExternalList } from 'helpers/actions'
import moment from 'helpers/moment'

export const ReportsRoute = (store) => Object.assign({}, authRoute(store), {
  path: 'reports(/:date)(/:report)',
  authentication: 'admin',
  getComponent (nextState, cb) {
    require.ensure([], (require) => {
      const Container = require('./containers/ReportsContainer').default

      const date = moment(nextState.params.date, { castAsTimezone: true }).format()
      injectExternalList(store, 'orders', date)

      cb(null, Container)
    }, 'orders')
  }
})

export default function (store) {
  return [
    ReportsRoute(store)
  ]
}



// WEBPACK FOOTER //
// ./src/routes/Reports/index.js